import React from 'react';
import { AvTooltip, AvTooltipProps } from '@fabric-ui/components';
import { FailFull as Error } from '@fabric-ui/icons/colorful';
import { flex } from '@fabric-ui/theme';
import { isNullOrUndefined } from '@fabric-ui/utils';
import { Box, SxProps, Tooltip } from '@mui/material';

const errorIcon = <Error />;

export function ErrorTooltip({
  error,
  children,
  open,
  sx,
}: {
  error: string;
  children: React.JSX.Element;
  open?: boolean;
  sx?: SxProps | AvTooltipProps['sx'];
}) {
  return (
    <AvTooltip
      variant="message"
      color="white"
      muiProps={isNullOrUndefined(open) ? {} : { open }}
      hasWidthLimit={false}
      title={
        <Box sx={{ ...flex.itemsCenter, gap: 1 }}>
          {errorIcon}
          {error}
        </Box>
      }
      sx={sx}>
      {children}
    </AvTooltip>
  );
}

export function InputTooltipWrapper({
  tooltipContent,
  error,
  inputNode,
  value,
  children,
  sx,
}: {
  tooltipContent?: string | React.ReactNode;
  error?: any;
  inputNode?: HTMLInputElement | null;
  value?: string | number | readonly string[];
  children: any;
  sx?: AvTooltipProps['sx'] | SxProps;
}) {
  return tooltipContent ? (
    <AvTooltip variant="message" color="white" title={tooltipContent} sx={sx}>
      {children}
    </AvTooltip>
  ) : error ? (
    <ErrorTooltip error={error} sx={sx}>
      {children}
    </ErrorTooltip>
  ) : (
    <Tooltip title={inputNode && inputNode.scrollWidth > inputNode.clientWidth ? value : ''} placement="bottom" sx={sx}>
      {children}
    </Tooltip>
  );
}
